import { c as _c } from "react/compiler-runtime";
import { ArrowDownNarrowWide, ArrowUpNarrowWide, ChevronsDownUp, ChevronsUpDown } from "lucide-react";
import type { ChapterSortDirection } from "@/lib/reader/volume-chapter-groups";
import { cn } from "@/lib/utils";
interface VolumeContentsControlsProps {
  direction: ChapterSortDirection;
  areAllExpanded: boolean;
  onToggleDirection: () => void;
  onToggleAll: () => void;
  showVolumeToggle?: boolean;
  className?: string;
}
export function VolumeContentsControls(t0) {
  const $ = _c(18);
  const {
    direction,
    areAllExpanded,
    onToggleDirection,
    onToggleAll,
    showVolumeToggle: t1,
    className
  } = t0;
  const showVolumeToggle = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== className) {
    t2 = cn("flex flex-wrap items-center justify-end gap-2", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== areAllExpanded || $[3] !== onToggleAll || $[4] !== showVolumeToggle) {
    t3 = showVolumeToggle && <button type="button" onClick={onToggleAll} aria-label={areAllExpanded ? "Collapse all volumes" : "Expand all volumes"} className="inline-flex items-center gap-1.5 rounded-full border border-border px-3 py-1.5 text-xs font-semibold text-foreground transition-colors hover:bg-secondary/60">{areAllExpanded ? <ChevronsDownUp className="size-3.5" /> : <ChevronsUpDown className="size-3.5" />}{areAllExpanded ? "Collapse all" : "Expand all"}</button>;
    $[2] = areAllExpanded;
    $[3] = onToggleAll;
    $[4] = showVolumeToggle;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = direction === "desc";
  const t5 = `Chapters sorted ${direction === "asc" ? "ascending" : "descending"}; click to reverse`;
  let t6;
  if ($[6] !== direction) {
    t6 = direction === "asc" ? <ArrowDownNarrowWide className="size-3.5" /> : <ArrowUpNarrowWide className="size-3.5" />;
    $[6] = direction;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = direction === "asc" ? "Ascending" : "Descending";
  let t8;
  if ($[8] !== onToggleDirection || $[9] !== t4 || $[10] !== t5 || $[11] !== t6 || $[12] !== t7) {
    t8 = <button type="button" onClick={onToggleDirection} aria-pressed={t4} aria-label={t5} className="inline-flex items-center gap-1.5 rounded-full border border-border px-3 py-1.5 text-xs font-semibold text-foreground transition-colors hover:bg-secondary/60">{t6}{t7}</button>;
    $[8] = onToggleDirection;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t2 || $[15] !== t3 || $[16] !== t8) {
    t9 = <div className={t2}>{t3}{t8}</div>;
    $[14] = t2;
    $[15] = t3;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
}